import { html, css } from 'lit';
import KaiElement from '../base';

class CategoryBarElement extends KaiElement {
  static get is() {
    return 'kai-categorybar';
  }

  static get properties() {
    return {
      items: { type: Array },
      selected: { type: String },
      disabled: { type: Boolean },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        .container {
          width: 100%;
          height: 7rem;
          color: var(--color-gs100);
          background-color: var(--color-gs00);
          display: flex;
          justify-content: space-around;
          align-items: flex-start;
          text-align: center !important;
          overflow: hidden;
          padding: 0 1.5rem;
          padding-top: 0.8rem;
          box-sizing: border-box;
        }

        .item {
          height: 4rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .disabled {
          pointer-events: none;
          opacity: var(--disabled-opacity);
        }

        p {
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: block;
          pointer-events: none;
          margin: 0;
        }

        i {
          width: 100%;
          height: 100%;
          border-radius: 2.5rem;
          border: solid 0.2rem var(--color-gs80);
          font-size: 2.6rem;
          display: none;
          pointer-events: none;
        }

        .selected p {
          display: none;
        }

        .selected i {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .fixed-text {
          font-size: 1.4rem;
        }
      `,
    ];
  }

  constructor() {
    super();
    this.items = [];
    this.selected = '';
    this.disabled = false;
  }

  getItemWidth() {
    const itemNum = this.items.length;
    switch (itemNum) {
      case 2:
        return '35%';
      case 3:
        return '31%';
      case 4:
        return '23%';
      default:
        return '35%';
    }
  }

  firstUpdated() {
    super.firstUpdated();
    /* the maximum number of category items is 4 */
    if (this.items.length > 4) {
      this.items = this.items.slice(0, 4);
    }
    /* set width based on the number of category items */
    const itemElements = this.shadowRoot.querySelectorAll('.item');
    itemElements.forEach(item => {
      item.style.width = this.getItemWidth();
    });
  }

  updated() {
    if (this.items.length < 1) {
      return;
    }
    const firstChildValue = this.items[0].value;
    const selectedValue = this.selected ? this.selected : firstChildValue;
    const itemElements = this.shadowRoot.querySelectorAll('.item');
    itemElements.forEach(item => {
      if (item.value === selectedValue) {
        item.classList.add('selected');
      } else {
        item.classList.remove('selected');
      }
    });
  }

  _clickHandler(e) {
    this.selected = e.target.value;
    const event = new CustomEvent('select', {
      detail: { selected: e.target.value },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }

  render() {
    return html`
      <div class="container">
        ${this.items.map(
          item =>
            html`
              <div
                class="item ${this.disabled ? 'disabled' : ''}"
                .value=${item.value}
                @click=${this._clickHandler}
                role="button"
                aria-label=${item.label}
              >
                <p class="h5 fixed-text" dir="auto">${item.label}</p>
                <i data-icon="${item.icon}"></i>
              </div>
            `
        )}
      </div>
    `;
  }
}

customElements.define(CategoryBarElement.is, CategoryBarElement);
